import React from 'react';

import IFormatterEntry from 'common/types/IFormatterEntry';

const PayoutAddressButtons = ({ entry, action }: IFormatterEntry) => (
  <button onClick={() => action!(entry)} className="primary small">Edit</button>
);


export default PayoutAddressButtons;
